<template>
  <div>
    <page-title title_text="لیست خروجی های اکسل">
<!--      <button-->
<!--              class="btn btn border bg-white shadow-sm mx-2 px-4 py-2"-->
<!--              type="button"-->
<!--              style="border-radius: 20px; border-color: #bbb"-->
<!--              @click="exportToExcel()"-->
<!--      >-->
<!--        <svg-->
<!--                xmlns="http://www.w3.org/2000/svg"-->
<!--                enable-background="new 0 0 24 24"-->
<!--                height="24"-->
<!--                viewBox="0 0 24 24"-->
<!--                width="24"-->
<!--                fill="#00bea5"-->
<!--        >-->
<!--            <g><rect fill="none" height="24" width="24" /></g>-->
<!--            <g>-->
<!--                <path-->
<!--                        d="M16.59,9H15V4c0-0.55-0.45-1-1-1h-4C9.45,3,9,3.45,9,4v5H7.41c-0.89,0-1.34,1.08-0.71,1.71l4.59,4.59 c0.39,0.39,1.02,0.39,1.41,0l4.59-4.59C17.92,10.08,17.48,9,16.59,9z M5,19c0,0.55,0.45,1,1,1h12c0.55,0,1-0.45,1-1s-0.45-1-1-1H6 C5.45,18,5,18.45,5,19z"-->
<!--                />-->
<!--            </g>-->
<!--        </svg>-->
<!--        <span class="pr-2">خروجی اکسل</span>-->
<!--      </button>-->
    </page-title>

    <div class="bg-white shadow-sm p-3 my-3" style="border-radius: 10px">
      <form @submit.prevent="excelExport($event , excel_query)" id="excel-transaction-filter-form">
        <div class="row">
          <div class="col-sm my-2">
            <div class="form-group my-0">
              <select
                  multiple
                  class="form-control kt-selectpicker"
                  v-model="excel_query.transaction_type"
                  id="filter_transaction_type"
                  name="transaction_type"
              >
                <option
                    v-for="transaction in transactionsTypes"
                    :key="transaction.name"
                    :value="transaction.value"
                    :disabled="transaction.disable"
                    :selected="transaction.disable ? true : false"
                >
                  {{ transaction.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-sm my-2">
            <div class="form-group my-0">
              <select
                  class="form-control kt-selectpicker"
                  v-model="excel_query.status"
                  id="filter_status"
                  name="status"
              >
                <option :value="null" selected disabled>وضعیت</option>
                <option v-for="status in transactionStatus" :key="status" :value="status">
                  {{ statusStr.get(status) }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-sm-2 my-2">
            <div class="form-group my-0">
              <datePicker
                  color="#00c1a4"
                  format="YYYY-MM-DD HH:mm:ss"
                  display-format="dddd jDD jMMMM jYYYY HH:mm"
                  input-class="form-control"
                  id="filter_from_date"
                  name="from_date"
                  placeholder="از تاریخ"
                  clearable
                  v-model="excel_query.from_date"
                  type="datetime"
              />
            </div>
          </div>
          <div class="col-sm-2 my-2">
            <div class="form-group my-0">
              <datePicker
                  color="#00c1a4"
                  format="YYYY-MM-DD HH:mm:ss"
                  display-format="dddd jDD jMMMM jYYYY HH:mm"
                  input-class="form-control"
                  id="filter_to_date"
                  name="to_date"
                  placeholder="تا تاریخ"
                  clearable
                  v-model="excel_query.to_date"
                  type="datetime"
              />
            </div>
          </div>
          <div class="col-sm-2 my-2">
            <select
                class="form-control kt-selectpicker"
                v-model="selectedShop"
                name="filter_gateway"
                id="filter_gateway"
            >
              <option :value="null" selected disabled>{{ $t('label.gateway') }}</option>
              <option
                  v-for="shop in shop_data_gateway"
                  :key="shop.hashid"
                  :value="shop"
              >
                {{ shop.title }} - {{ getShopType(shop.shop_type) }} - {{ shop.sequence }}
              </option>
            </select>
          </div>
          <div class="col-sm-2 my-2"  v-if="selectedShop !== null">
            <select
                class="form-control kt-selectpicker"
                v-model="excel_query.terminal_number"
                name="terminal_number"
                id="terminal_number"
            >
              <option :value="null" selected disabled>{{ $t('label.terminal_number') }}</option>
              <option
                  v-for="terminal in filteredTerminals"
                  :key="terminal.id"
                  :value="terminal.id"
              >
                {{ $t(`psp.${terminal.psp}`) }} - {{ terminal.number || 'N/A' }}
              </option>
            </select>
          </div>
          <div class="col-sm my-2">
            <div class="d-flex">
              <button
                :class="excel_query ? 'btn btn-success' : 'btn btn-success btn-block'"
                style="border-radius: 10px"
                type="submit"
              >
                خروجی اکسل تراکنش ها
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="px-3 bg-white shadow-sm py-3 my-4">
      <div v-if="excelRequests && excelRequests.data.length > 0" class="d-md-none">
        <div
            class="xl-card"
            v-for="req in excelRequests.data"
            :key="'m' + req.id"
            :class="'xl-' + String(req.status).toLowerCase()"
        >
          <div class="d-flex justify-content-between align-items-center">
            <span class="xl-status">
              <i v-if="req.status == 'PROCESSING'" class="fa fa-spinner fa-spin"></i>
              {{ excelStatusStr(req.status) }}
            </span>
            <span class="xl-code en_num">{{ req.id }}</span>
          </div>
          <div class="xl-dates">
            <div>
              <small>از تاریخ</small>
              <b class="en_num">{{ req.from_date }}</b>
            </div>
            <div>
              <small>تا تاریخ</small>
              <b class="en_num">{{ req.to_date }}</b>
            </div>
          </div>
          <div class="xl-actions">
            <a v-if="req.url" :href="req.url" class="xl-btn xl-btn--download">
              <i class="fa fa-download"></i> دانلود فایل
            </a>
            <span v-else class="xl-btn xl-btn--off">
              {{ req.status == 'PROCESSED' ? 'فایل در دسترس نیست' : 'فایل هنوز آماده نیست' }}
            </span>
            <button type="button" class="xl-btn xl-btn--delete" @click="handleReqDelete(req.id)">
              <i class="fa fa-trash"></i> حذف
            </button>
          </div>
        </div>
      </div>
      <div class="table-responsive">
        <table
            class="table table-responsive table-borderless text-center d-none d-md-table"
            v-if="excelRequests && excelRequests.data.length > 0"
        >
          <thead>
            <th
              scope="col"
              style="background-color: #eee; border-radius: 0 16px 16px 0"
            >
              #
            </th>
            <th
              scope="col" style="background-color: #eee"
            >
              از تاریخ
            </th>
            <th
              scope="col" style="background-color: #eee"
            >
              تا تاریخ
            </th>
            <th
              scope="col" style="background-color: #eee"
            >
              وضعیت
            </th>
            <th
                scope="col" style="background-color: #eee; border-radius: 16px 0 0 16px"
            >
              عملیات
            </th>
          </thead>
          <tbody>
            <tr v-for="(req, index) in excelRequests.data" :key="index">
              <td>{{ req.id }}</td>
              <td>{{ req.from_date }}</td>
              <td>{{ req.to_date }}</td>
              <td>
                <div class="text-white" :class="excelStatusVariant(req.status)">
                  {{ excelStatusStr(req.status) }}
                </div>
              </td>
              <td>
                <div class="d-flex justify-content-center align-items-center">
                  <a v-show="req.url" :href="req.url" title="دانلود فایل" type="button" style="background: none; border: none; color: #7f7fee">
                    <i class="fa fa-download"></i>
                  </a>
                  <button @click="handleReqDelete(req.id)" title="حذف" style="background: none; border: none; color: #fc2e2e">
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-else class="text-white text-center my-3">درخواست خروجی اکسل برای شما وجود ندارد!</div>

        <hr v-if="excelRequests.next_page_url || excelRequests.prev_page_url" />

        <pagination
            v-if="excelRequests && excelRequests.data.length > 0"
            :data="excelRequests"
            :get_data="get_data"
            :perpage="perpage"
        ></pagination>
      </div>
    </div>

  </div>
</template>
<script>
import PageTitle from "@/components/main/components/pageTitle.vue";
import {transactionsTypes} from '@/constants/TransactionsTypes';
import {statusStr , transactionStatus} from '@/constants/transactionStatus';
import toastr from "toastr";
import {i18n} from "@/plugins/i18n";
import {ApiService, transactionService} from "@/common/api.service";
import Pagination from "@/components/main/pagination.vue";
import $ from "jquery";
import {mapGetters} from "vuex";
import {AllShopTypes} from "@/constants/AllShopTypes";


export default {
  name: "ExcelRequests",
  components: {Pagination, PageTitle},
  props: {
    excelRequests: {
      required: true,
      default: []
    }
  },
  data(){
    return {
      excel_query: {
        terminal_number: null,
        transaction_type: null,
        status: null,
        from_date: null,
        to_date: null,
      },
      transactionStatus,
      statusStr,
      transactionsTypes,
      selectedShop: null,
      selectedTerminal: null,
      filteredTerminals: [],
      perpage: {
        value: 15,
      },
    }
  },
  computed: {
    toastr() {
      toastr.options = {
        closeButton: true,
        positionClass: "toast-bottom-center",
        preventDuplicates: false,
        rtl: false
      }
      return toastr
    },
    ...mapGetters('gateway', [
      'shop_data_gateway',
    ]),
  },
  methods:{
    excelExport(event, excel_query){
      this.$emit('handle-excel-export' , { excel_query: excel_query, event: event })
    },
    get_data(url, callback = () => {}) {
      ApiService.query(
          url + "&perpage=" + this.perpage.value
      ).then((json) => {
        this.excelRequests = json.data.data;

        callback();
      });
    },
    handleReqDelete(hashid){
      transactionService.deleteExcelRequest(hashid)
          .then(response => {
            this.toastr.success(response.data.message);
            this.$store.dispatch('transaction/fetchExcelRequests', this.params).finally(() => {
              localStorage.setItem('excelRequests_per_page', this.excelRequests.per_page)
            })
          })
          .catch(({response}) => {
            this.toastr.error(response.data.message);
          })
    },
    excelStatusStr(status){
      if (status == "CREATED")
        return i18n.t('transaction.excelStatus.created')

      if (status == "PROCESSING")
        return i18n.t('transaction.excelStatus.processing')

      if (status == "PROCESSED")
        return i18n.t('transaction.excelStatus.processed')
    },
    excelStatusVariant(status){
      if (status == "CREATED")
        return "badge badge-secondary"

      if (status == "PROCESSING")
        return "badge badge-warning"

      if (status == "PROCESSED")
        return "badge badge-success"
    },
    getShopType(shop_type) {
      if (shop_type == AllShopTypes.PAYMENT_HELPER) {
        return  i18n.t('label.payment_helper')
      }
      if (shop_type == AllShopTypes.PAYMAN) {
        return  i18n.t('label.payman')
      }
      if (shop_type == AllShopTypes.IVR) {
        return  i18n.t('label.ivr')
      }
      if (shop_type == AllShopTypes.DEDICATED) {
        return  i18n.t('label.dedicated')
      }
    },
  },
  watch: {
  selectedShop(newShop) {
    this.filteredTerminals = newShop ? newShop.terminals : [];
    this.selectedTerminal = null;
  }
  },
  mounted() {
    setTimeout(function () {
      $(".kt-selectpicker").selectpicker({
        size: 5,
        liveSearch: true,
        noneResultsText: i18n.t("selectpicker.none_result"),
        selectAllText: i18n.t("selectpicker.select_all"),
        noneSelectedText: i18n.t('label.transaction_type'),
      });
    }, 100);
  }
}

</script>

<style scoped>
.xl-card {
  --xl-accent: #b5b5c3;
  margin-bottom: 14px;
  padding: 12px 14px;
  background: rgba(128, 128, 128, 0.1);
  border: 1px solid rgba(128, 128, 128, 0.35);
  border-inline-start: 4px solid var(--xl-accent);
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
}
.xl-card.xl-processing { --xl-accent: #ffa800; }
.xl-card.xl-processed { --xl-accent: #1bc5bd; }
.xl-status {
  padding: 1px 10px;
  border: 1px solid var(--xl-accent);
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 700;
  color: var(--xl-accent);
}
.xl-code {
  font-size: 0.8rem;
  opacity: 0.6;
}
.xl-dates {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin: 12px 0;
  padding: 8px 0;
  border-top: 1px dashed rgba(128, 128, 128, 0.4);
  border-bottom: 1px dashed rgba(128, 128, 128, 0.4);
}
.xl-dates small {
  display: block;
  opacity: 0.7;
}
.xl-actions {
  display: flex;
  gap: 8px;
}
.xl-btn {
  flex: 1;
  padding: 6px 8px;
  border-radius: 10px;
  border: 1px solid var(--xl-accent);
  background: transparent;
  color: inherit;
  font-size: 0.8rem;
  text-align: center;
}
.xl-btn--download {
  border-color: #1bc5bd;
  color: #1bc5bd;
}
.xl-btn--delete {
  flex: 0 0 90px;
  border-color: #f64e60;
  color: #f64e60;
}
.xl-btn--off {
  border-style: dashed;
  border-color: rgba(128, 128, 128, 0.5);
  opacity: 0.7;
}
</style>